module.exports = __webpack_public_path__ + "img/foyer-and-entryway.4a09d20.jpeg";